import { environment } from "src/environments/environment";

/**
 * Helper functions para construir endpoints de API de forma type-safe
 * Evita concatenación manual y errores de tipos
 */

// Helper para construir endpoints con parámetros
export function buildEndpoint(
	baseEndpoint: string,
	...params: (string | number)[]
): string {
	return baseEndpoint + (params.length > 0 ? `/${params.join("/")}` : "");
}

// Endpoints específicos con functions helper type-safe
export const API_ENDPOINTS = {
	// Centro endpoints
	centro: {
		list: () => environment.endpoint.centros.list,
		getById: (id: number) =>
			buildEndpoint(environment.endpoint.centros.getCentroById, id),
		getByCebes: (id: number) =>
			`${environment.endpoint.centros.getCentroByCebes}/${id}/centros`,
		getByContratos: (id: number) =>
			buildEndpoint(environment.endpoint.centros.getCentroByContrato, id),
		update: (id: number) =>
			buildEndpoint(environment.endpoint.centros.updateCentro, id),
		create: () => environment.endpoint.centros.createCentro,
		uploadUsers: () => environment.endpoint.centros.uploadUsers,
		getCebeCentro: () =>
			environment.endpoint.centros.getContratoCentroByCentro,
		exportToExcel: (centroId?: number) => {
			const baseUrl = environment.endpoint.centros.exportToExcel;
			return centroId !== undefined
				? `${baseUrl}?centroId=${centroId}`
				: baseUrl;
		},
		validar: (id: number) =>
			buildEndpoint(environment.endpoint.centros.Validar, id),
		listoMigrar: (id: number) =>
			buildEndpoint(environment.endpoint.centros.ListoMigrar, id),
	},

	// Site endpoints
	site: {
		get: () => environment.endpoint.site.get,
		find: (code: string) =>
			buildEndpoint(environment.endpoint.site.find, code),
		getByServiceCode: (serviceCode: string) =>
			buildEndpoint(
				environment.endpoint.site.getByServiceCode,
				serviceCode,
			),
	},

	// Cebes endpoints
	cebes: {
		list: () => environment.endpoint.contratos.getContratosList,
		getById: (cebeId: number) =>
			buildEndpoint(
				environment.endpoint.contratos.getContratoById,
				cebeId,
			),
		update: () => environment.endpoint.contratos.updateContrato,
		uploadFinancialData: () =>
			environment.endpoint.contratos.uploadFinancialData,
		notificacionCese: (id: number) =>
			buildEndpoint(environment.endpoint.contratos.notificacionCese, id),
		notificacionAlta: (id: number) =>
			buildEndpoint(environment.endpoint.contratos.notificacionAlta, id),
	},

	// Master endpoints
	master: {
		empleados: () => environment.endpoint.master.getEmpleadosList,
		actividades: () => environment.endpoint.master.getActividadList,
		paises: () => environment.endpoint.master.getPaisList,
		zonas: (sociedadId: number) =>
			buildEndpoint(environment.endpoint.master.getZonaList, sociedadId),
		zonasByResponsable: (sociedadId: number, responsableId: number) =>
			buildEndpoint(
				environment.endpoint.master
					.getZonaListZonaBySociedadByResponsable,
				sociedadId,
				responsableId,
			),
		sociedadById: (id: number) =>
			buildEndpoint(environment.endpoint.master.getSociedadById, id),
		tiposProyecto: () => environment.endpoint.master.getTipoProyectoList,
		adquisicionReactivos: () =>
			environment.endpoint.master.getAdquisicionReactivosList,
		contratoElectricidad: () =>
			environment.endpoint.master.getContratoElectricidadList,
	},

	// Admin endpoints
	admin: {
		getById: (adminId: number) =>
			buildEndpoint(environment.endpoint.admin.getAdminById, adminId),
		update: () => environment.endpoint.admin.updateAdmin,
		exportToExcel: () => environment.endpoint.admin.exportToExcel,
	},

	// Settings endpoints
	settings: {
		fav: (service: string) =>
			buildEndpoint(environment.endpoint.settings.fav, service),
		unfav: (service: string) =>
			buildEndpoint(environment.endpoint.settings.unfav, service),
		favPages: () => environment.endpoint.settings.favPages,
		favPage: () => environment.endpoint.settings.favPage,
		unfavPage: () => environment.endpoint.settings.unfavPage,
		user: () => environment.endpoint.settings.user,
		isAdmin: () => environment.endpoint.settings.isAdmin,
	},

	// Tag endpoints
	tag: {
		get: () => environment.endpoint.tag.get,
	},
} as const;
